import React, { useEffect, useState } from 'react'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../../common/snippets'
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import { PdfFooter, partyViewLimitUsagesCol, partyViewLimitUsagesColForPDFExcel, viewLimitUsagesHeaderCol } from './constant'
import { backGroundColorForStatus, isEmpty, removeDuplicatesFromArray } from '../../../../common/helper'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import autoTable from 'jspdf-autotable'
import { connect } from 'react-redux'
import { getPartyCreditUsageReportData, getOwnChildBranches } from '../../../../../store/reports/reports_action'
import { GetRequest, PostRequest } from '../../../../common/api'
import { urls } from '../../../../common/constants'
const PartyViewLimitUses = (props) => {
    const theme = useTheme()
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const { setViewLimit, data, getOwnChildBranches, getPartyCreditUsageReportData } = props
    const { common, reports } = data
    const { loginData, roleRights } = common
    const { ownChildBranches1, reportBranchList, partyCreditUsageReportData } = reports
    const { generatePDF, load } = { ...state }
    const [showTable, setShowTable] = useState(true)
    const [sourceCityList, setSourceCityList] = useState([])
    const [selSourceCity, setSelSourceCity] = useState([])
    const [sourceBranchList, setSourceBranchList] = useState([])
    const [selSourceBranch, setSelSourceBranch] = useState()
    const [tableData, setTableData] = useState([])
    const [resPartyCity, setResPartyCity] = useState([])
    const [updatedRes, setUpdatedRes] = useState([])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const branchData = {
                intUserID: loginData?.intUserID,
                intCompanyID: loginData?.intCompanyID,
                intIsActive: 1,
            }
            getOwnChildBranches(branchData)
            //   setSelSourceBranch({ BranchName: loginData?.strBranchName, BranchID: loginData?.intBranchID })
        }
    }, [loginData])
    useEffect(() => {
        const data = partyCreditUsageReportData?.map((val, index) => ({ ...val, SN: index + 1,BranchCode:val?.PartyID,BranchName:val?.Party,CityName:val?.PartyCity,CargoBalance:val?.RemainingCredit }))
        setTableData(data)
    }, [partyCreditUsageReportData])
    useEffect(() => {
        const partyCity = resPartyCity.flatMap((party) => {
            const cityIds = party.CityID.split("~");
            const cityNames = party.PartyCitiesNames.split("~");
            return cityIds.map((id, index) => ({
                PartyID: party.PartyID,
                Party: party.Party,
                CityID: id,
                CityName: cityNames[index] || "",
            }));
        });
        setUpdatedRes(partyCity)
    }, [resPartyCity])
    useEffect(() => {
        const cities = updatedRes?.map(record => ({
            CityID: record.CityID,
            CityName: record.CityName,
        }));
        const cityList = removeDuplicatesFromArray(cities, 'CityID')
        const partyList = removeDuplicatesFromArray(updatedRes, 'PartyID')
        setSourceCityList([{ CityName: 'All', CityID: 0 }, ...cityList])
        setSourceBranchList([{ Party: 'All', PartyID: 0 }, ...partyList])
    }, [updatedRes])
    useEffect(() => {
        const loginCity = sourceCityList?.filter((val) => val?.CityID === loginData?.intBranchCityID)
        if (loginCity?.length > 0) {
            setSelSourceCity(loginCity[0])
        } else {
            setSelSourceCity(sourceCityList[0])
        }
    }, [sourceCityList])

    useEffect(() => {
        setSelSourceBranch(sourceBranchList[0])
    }, [sourceBranchList])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const obj = {
                intPartyID: 0,
                intCompanyID: 1,
                strPartyName: "",
                strContactPerson: "",
                intCityID: 0,
                intIsCreditParty: -1,
                intIsActive: -1,
                intIsDeleted: 0
            }
            PostRequest(urls.getPartyList, obj).then((res) => {
                if (res.status === 'Success') {
                    setResPartyCity(res?.Data)
                }
            })
        }
    }, [loginData])
    const handleClick = () => {
        // setIsExpanded(true)
        const obj = {
            CompanyID: loginData?.intCompanyID,
            PartyID: selSourceBranch?.PartyID,
            CityID: selSourceCity?.CityID,
        }
        getPartyCreditUsageReportData(obj)
    }
    const InsideRowContent = ({ item, index }) => {
        return (
            <>
                <TableRow style={{ verticalAlign: 'top' }}>
                    <>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}
                        >
                            {item.SN}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                        >
                            {item.CompanyID}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                        >
                            {item.CompanyName}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                        >
                            {item.BranchCode}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                        >
                            {item.BranchName}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
                        >
                            {item.CityName}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{
                                fontSize: '12px',
                                background: 'F5FAFE',
                                fontWeight: '500',
                                textAlign: 'right',
                                whiteSpace: 'nowrap',
                                //color: typeof item.CreditLimit === 'number' ? 'red' : item.CreditLimit === 'Unlimited' ? 'green' : '#444',
                                color: item.CreditLimitType === 'Unlimited' ? 'green' : item.CreditLimitType === 'No Credit Limit' ? '' : 'red',
                            }}
                        >
                            {item.CreditLimitType}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
                        >
                            {item.CreditLimit}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
                        >
                            {item.LimitUsage}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
                        >
                            {item.LimitUsageInPer}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', background: 'F5FAFE', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
                        >
                            {item.CargoBalance}
                        </TableCell>
                        <TableCell
                            className="reportTD"
                            colSpan={1}
                            style={{ fontSize: '12px', color: item.Status === 'Active' ? '#3C763C' : '#F05924', fontWeight: 'bold' }}
                            title={item.Status}
                        >
                            <span
                                className="status"
                                style={{
                                    backgroundColor: backGroundColorForStatus[`${item.Status}`],
                                    padding: '5px 10px 5px 10px',
                                    borderRadius: '12px',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {item.Status}
                            </span>
                        </TableCell>
                    </>
                </TableRow>
            </>
        )
    }
    const printClick = (isSave) => {
        setShowTable(false)
        setState({ ...state, load: true, generatePDF: true })
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

        const pdfColumns = partyViewLimitUsagesColForPDFExcel.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const HeaderColumns = viewLimitUsagesHeaderCol.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const HeaderData = [
            {
                company: loginData?.strCompanyName,
                city: selSourceCity?.CityName,
                branch: selSourceBranch?.BranchName,
            },
        ]
        // bodyData for credit usage report
        // const bodyData = tableData?.map((item, index) =>
        //     item.isTotal
        //         ? item
        //         : {
        //             srNo: index + 1,
        //             state: item.StateName,
        //             city: item.CityName,
        //             branch: item.BranchName,
        //             creditLimit: item.CreditLimit,
        //             limitUsage: item.LimitUsage,
        //             usageInPer: item.LimitUsageInPer,
        //             remainingLimit: item.CargoBalance,
        //             status: item.Status,
        //         }
        // )
        const doc = new jsPDF({ orientation: 'P', format: [1156, 1636], unit: 'px', compress: true })
        var totalPagesExp = '{total_pages_count_string}'
        doc.setProperties({
            title: `View Limit Usages.pdf`,
            subject: 'View Limit Usages',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Receive',
            creator: 'MTLPL',
        })
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: HeaderData,
            columnStyles: {
                0: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
                1: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
                2: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
                3: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
                4: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
                5: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
                6: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'right', textColor: [0, 0, 0], },
                7: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'right', textColor: [0, 0, 0], },
                8: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'right', textColor: [0, 0, 0], },
                9: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'right', textColor: [0, 0, 0], },
                10: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'right', textColor: [0, 0, 0], },
                11: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'right', textColor: [0, 0, 0], },

            },
            theme: 'grid',
            startY: 120,
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: 18,
                font: 'Roboto',
                fontStyle: 'normal',
                lineWidth: 0.6,
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(18).setFont('Roboto', 'bold')
                // doc.text(
                //   `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
                //   data.settings.margin.left,
                //   150
                // )
                // doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
            },
        })
        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            headStyles: {
                fillColor: [191, 225, 255],
                fontSize: 16,
                minCellHeight: 36,
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'normal',
                font: 'Roboto',
                textColor: [0, 0, 0],
            },
            tableLineWidth: 0.6,
            columns: pdfColumns,
            body: tableData,
            styles: {
                lineWidth: [0, 0.2, 0, 0.2],
            },
            //---------------data of table-----------
            columnStyles: {
                0: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                1: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                2: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                3: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                4: {
                    halign: 'right',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                5: {
                    halign: 'right',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                6: {
                    halign: 'right',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                7: {
                    halign: 'right',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                8: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                9: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                10: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
                11: {
                    halign: 'left',
                    minCellHeight: 36,
                    fontSize: 16,
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'normal',
                    font: 'Roboto',
                    textColor: [0, 0, 0],
                },
            },
            theme: 'grid',
            // didParseCell: (data) => {
            //     crdeitDrawCellDetail(data)
            // },
            didDrawPage: function (data) {
                doc.setTextColor(40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                doc.setFontSize(26).setFont('Roboto', 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | View Limit Usages', 30 + 60, 80)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(22).setFont('Roboto', 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
                PdfFooter(data, loginData, totalPagesExp)
            },
            // showHead: 'never',
        })
        doc.setFont('Roboto')

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`View Limit Usages ${new Date().getTime()}.pdf`)
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                document.getElementById('branchRechargeHistoryViewLimitUses').data = doc.output('datauristring', 'View Limit Usages.pdf')
                // focusElemnt('backBtn')
            }, 2000)
        } else {
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                document.getElementById('branchRechargeHistoryViewLimitUses').data = doc.output('datauristring', 'View Limit Usages.pdf')
                // focusElemnt('backBtn')
            }, 2000)
        }
    }
    const clickElement = (elementID) => {
        elementID && document.getElementById(elementID) && document.getElementById(elementID).click()
    }
    const selectedCity = (val) => {
        setSelSourceCity(val)
        let result = updatedRes?.filter((obj) => obj.CityID === val.CityID || val?.CityID === 0 || obj.PartyID === 0)
        setSourceBranchList([{ PartyID: 0, Party: 'All' }, ...result])
    }
    return (
        <>
            <Item sx={{ padding: '0' }} >
                <Box sx={sx.reportFlex} className='reportButton'>
                    {
                        showTable ? (<>

                            <Item sx={sx.itemsx}>
                                <DropDownOA
                                    id={'selectCompany'}
                                    label={'Select Company'}
                                    defaultvalue={loginData.strCompanyName}
                                    disabled={true}
                                    minWidth="250px"
                                    width="300px"
                                />
                            </Item>
                            <Item sx={sx.itemsx}>
                                <DropDownOA
                                    id={'partyCity'}
                                    label={'Party City'}
                                    data={sourceCityList}
                                    defaultvalue={selSourceCity?.CityName}
                                    idKey={`CityID`}
                                    dataKey={`CityName`}
                                    onSelect={(val) => {
                                        selectedCity(val)
                                    }}
                                    isObjArr={true}
                                    searchPlaceholder={`Search By Branch City`}
                                    width="100%"
                                // nextId={id.srcBranch}
                                // prevId={id.stateId}
                                // resetFlag={resetFlag || resetCity}
                                // disabled={disableBtn}
                                />
                            </Item>
                            <Item sx={sx.itemsx}>
                                <DropDownOA
                                    id={'partyName'}
                                    label={'Party Name'}
                                    data={sourceBranchList}
                                    defaultvalue={selSourceBranch?.Party || ''}
                                    idKey={`PartyID`}
                                    dataKey={`Party`}
                                    onSelect={(val) => {
                                        // setIsExpanded(false)
                                        setSelSourceBranch(val)
                                    }}
                                    isObjArr={true}
                                    searchPlaceholder={`Search By Party Name`}
                                    width="100%"
                                // nextId={id.creditUsageSplitButton}
                                // prevId={id.srcCity}
                                // resetFlag={resetFlag || resetCity}
                                // disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                                />
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper" style={{ padding: '0px' }}>
                                <Button variant="contained" style={{ ...sx.fullHeight, ...sx.novp, fontSize: '16px' }} className="btn btn-primary" onClick={handleClick}>
                                    LOAD
                                </Button>
                            </Item>
                            <Item className="disabled-wrapper" style={{ padding: '0px' }} >
                                <Button id={"CANCEL"} variant="outlined" sx={{ width: '100%', fontSize: '16px' }} className="receiveitembtn"
                                    onClick={() => printClick(false)}
                                // onKeyDown={(e) => {
                                //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                                // }}
                                >
                                    PRINT
                                </Button>
                            </Item>
                            <Box >
                                <Button id='view-xls-button' variant="outlined" sx={{ width: '100%', fontSize: '16px', color: '#fe5200' }} className="receiveitembtn"
                                    onClick={(e) => { clickElement('xls-buttons') }}
                                // onKeyDown={(e) => {
                                //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                                // }}
                                >
                                    EXCEL
                                </Button>
                                <ReactHtmlTableToExcel
                                    id="xls-buttons"
                                    table="tables"
                                    filename={'VIEW LIMIT USAGES'}
                                    sheet="sheet 1"
                                    buttonText="EXPORT AS EXCEL"
                                    className="excel-button"
                                />
                            </Box>
                            <Item className="disabled-wrapper" style={{ padding: '0px' }}>
                                <Button id={"CANCEL"} variant="outlined" sx={{ width: '100%', fontSize: '16px' }} className="receiveitembtn"
                                    onClick={() => setViewLimit(false)}
                                // onKeyDown={(e) => {
                                //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                                // }}
                                >
                                    BACK TO PARTY RECHARGE
                                </Button>
                            </Item>
                        </>) : (<>
                            <Box>
                                <Button
                                    style={{ border: '1px solid #fe5200', color: '#fe5200' }}
                                    id="backBtn"
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => (setShowTable(true))}
                                >
                                    Back
                                </Button>
                            </Box>
                        </>)
                    }
                    {
                        showTable ? (<>
                            <TableContainer className="scroll" style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)' }}>
                                <Table id="tables" className="table1 table-Report" size="small" aria-label="a dense table">
                                    <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                                        <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                                            {partyViewLimitUsagesCol?.map((item, i) =>
                                                <TableCell key={i} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF",fontSize:'12px',whiteSpace:'nowrap' }}>{item?.headerName}</TableCell>
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    {tableData?.length < 1 ? (
                                        <>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={15}>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                marginTop: '20px',
                                                                marginBottom: '20px',
                                                                color: 'red',
                                                                fontSize: '12px',
                                                                lineheight: '16px',
                                                                letterspacing: '0.24px',
                                                            }}
                                                        >
                                                            <span>No results found. Please refine your search parameters and search again.</span>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </>
                                    ) : tableData?.length >= 1 ? (
                                        <TableBody
                                            className="filter-data-row"
                                            style={{
                                                textAlign: 'center',
                                                fontSize: '12px',
                                                lineheight: '16px',
                                                letterspacing: '0.24px',
                                                fontWeight: '500',
                                                marginLeft: '5px',
                                            }}
                                        >
                                            {tableData?.map((item, index) => (
                                                <InsideRowContent item={item} index={index} key={index} />
                                            ))}
                                        </TableBody>
                                    ) : (
                                        ''
                                    )}
                                </Table>
                            </TableContainer>
                        </>) : (
                            <>
                                {generatePDF ? <div style={{ textAlign: 'center' }} className={'generatePDF'}>Generating PDF....</div> : ''}
                                {load ? (
                                    <object
                                        id="branchRechargeHistoryViewLimitUses"
                                        type="application/pdf"
                                        width={'100%'}
                                        height="440"
                                        title="MTLPL -Cargo System - After Transfer Summary Report"
                                        aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                                        style={{ marginTop: '10px', textAlign: 'center' }}
                                    ></object>
                                ) : (
                                    ''
                                )}
                            </>
                        )
                    }
                </Box>
            </Item>
        </>
    )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    getOwnChildBranches,
    getPartyCreditUsageReportData
}
export default connect(mapStateToProps, mapDispatchToProps)(PartyViewLimitUses)